module.exports = __webpack_public_path__ + "img/p1-c3-p3.308baf9c.jpg";